import { render, staticRenderFns } from "./DashboardAdmission.vue?vue&type=template&id=78a2f550&scoped=true&"
import script from "./DashboardAdmission.vue?vue&type=script&lang=js&"
export * from "./DashboardAdmission.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdmission.vue?vue&type=style&index=0&id=78a2f550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2f550",
  null
  
)

export default component.exports